module.exports = __webpack_public_path__ + "img/icon-cursos.a6294b15.svg";